<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" :content="id ? '编辑店铺的等级' : '添加店铺的等级'"></el-page-header>
        <el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">

            <el-form-item label="名称" prop="name">
                <el-input v-model="item.name" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="服务费比例(%)" prop="service_fee">
                <el-input v-model="item.service_fee" oninput="value=value.replace(/\D|^0/g,'') > 100 ? 100 : value.replace(/\D|^0/g,'') " placeholder="请输入服务费比例;例如：抽五个点，请输入5"></el-input>
            </el-form-item>
            <el-form-item label="可发布商品数" prop="quantity">
                <el-input v-model="item.quantity" placeholder="请输入可发布商品数"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="orders">
                <el-input v-model="item.orders" placeholder="请输入排序"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="memo">
                <el-input v-model="item.memo" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
            </el-form-item>
            <el-form-item>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisible"
                        width="30%"
                >
                    <span>您确认保存嘛</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submit">确 定</el-button>
                    </span>
                </el-dialog>
            </el-form-item>

        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {},
                isLoad: false,
                id: this.$route.query.id,
                logo: [],
                options: [],
                dialogVisible: false,
                rules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                    ],
                    service_fee: [
                        {required: true, validator: this.$check.bailPaid, trigger: 'blur'},
                    ],
                    quantity: [
                        {required: true, validator: this.$check.bailPaid, trigger: 'blur'},
                    ]
                }
            }
        },
        created() {
            if (this.id) {
                this.loadData()
            }
        },
        methods: {
            loadData: function () {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('/admin/business.storeRank/detail', {
                    id: this.id
                }).then(res => {
                    this.isLoad = !this.isLoad
                    if (res) {
                        // item是基础信息
                        this.item = res.data.detail
                    }
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            checkSubmit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.dialogVisible = true
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },
            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.dialogVisible = false
                let url = ''
                if (this.id) {
                    url = '/admin/business.storeRank/update'

                    this.item.id = this.id

                } else {
                    url = '/admin/business.storeRank/add'
                }

                this.axios.post(url, this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>
